// What the host's audio manifest published, and the one way to the sound
// director, for the menu surfaces (R229, R814).
//
// The director is built in `fast/main.ts`, and the hub is handed no
// reference to it. `main.ts` therefore pushes two things in here before the
// hub opens: the sink that applies a written settings blob, and the choices
// the manifest published. The hub SETTINGS panel writes the sound switches
// through the sink. The MODDING panel reads the choices to draw the Music
// and the SFX pickers, and `ui/themestate.ts` writes a theme pick through
// the sink, so the pick is heard at once.
//
// The module holds no table of its own: the manifest is the one catalogue,
// and a host that publishes no manifest leaves `available` false.

import type { GameSettings } from './settings';

/** One playlist or SFX theme the manifest published. `key` is the tier
 *  mark (themes.md §4.2): absent is free. */
export interface AudioChoice {
  id: string;
  title: string;
  key?: string;
}

/** What the picker rows offer, pushed in by `main.ts` from the director. */
export interface AudioChoices {
  available: boolean;
  playlists: AudioChoice[];
  themes: AudioChoice[];
}

/** Nothing is published until `main.ts` says otherwise. */
let choices: AudioChoices = { available: false, playlists: [], themes: [] };

export function setAudioChoices(c: AudioChoices): void {
  choices = c;
}

/** What the manifest published, as `main.ts` pushed it last. */
export function audioChoices(): AudioChoices {
  return choices;
}

/** How a menu surface reaches the sound director. */
let sink: ((s: GameSettings) => void) | null = null;

export function setSettingsSink(fn: ((s: GameSettings) => void) | null): void { sink = fn; }

/** Hands one written blob to the director, where a sink is set. */
export function applyToSound(s: GameSettings): void { sink?.(s); }
